import React, { useState, useEffect} from "react";

import loginStore from "../../../flux/stores/loginStore";
import { Row } from "shards-react";
import AdminService from "../../../flux/services/AdminService";
import tableCustomerStyles from "../../../utils/tableCustomStyles";
import DataTable from "react-data-table-component";


export default function InvoiceDetails(props)
{
    let user = loginStore.getUserName();



    

    
 
   //alert(JSON.stringify(props))

    
    //alert(JSON.stringify(customerRecord))
 

    const [data, setData] = useState({
        paymentExperience: null,
        pfc: null,
        nsf: null,
        member: null
    });

    useEffect(() => {
        async function getInvoiceDetails(invoiceId, memberId)
        {


    
          try {
            // set loading to true before calling API
            const paymentExperience = await AdminService.getInvoiceDetails(invoiceId, 'Trade Report');
            const pfc = await AdminService.getInvoiceDetails(invoiceId, 'PFC Report');
            const nsf = await AdminService.getInvoiceDetails(invoiceId, 'NSF Report');
            const member = await AdminService.getMemberbyId(memberId);

            setData({
                paymentExperience: paymentExperience,
                pfc: pfc,
                nsf: nsf,
                member: member
            });

          } catch (error) {
            // add error handling here
            console.log(error);
          }

          
        }
        getInvoiceDetails(props.invoiceId, props.memberId);

      
        }, []);

    /*report_access_id, member_id, user_name, account_id, access_date, is_billable, attribute_value, attribute_description, account_name*/
  const paymentExperienceColumns = [
    {
      name: 'CCI Id',
      sortable: true,
      selector: data => data.account_id,
      width: '12%'
    },
    {
      name: 'CCI Account Name',
      sortable: true,
      wrap: true,
      selector: data => data.account_name,
      width: '25%'
    },
    {
      name: ('Date Accessed'),
      selector: data => data.access_date,
      cell: data => data.access_date.toString().substring(0,2) + '/' + data.access_date.toString().substring(3,5) + '/' + data.access_date.toString().substring(6,10),//data.access_date.toString(),//data.access_date.toString().substring(5,7) + '/' + data.access_date.toString().substring(8,10) + '/' + data.access_date.toString().substring(0,4),
      sortable: true,
      width: '15%'
    },
    {
      name: 'City',
      sortable: true,
      selector: data => data.city,
      wrap: true,
      width: '15%'
    },
    {
      name: 'State',
      sortable: true,
      selector: data => data.state,
      width: '8%'
    },
    {
      name: 'Zip',
      sortable: true,
      selector: data => data.zip,
      width: '12%'
    },
    {
      name: ('cost'),
      selector: data => data.attribute_value==null?'$0':'$' + data.attribute_value,
      sortable: true,
      wrap: true,
      width: '10%'
    }
    ]
    
  const PayementExperienceDataTable = (props) =>
  {
    // alert(JSON.stringify(specialNamesData))

    if (!data) return (
      <span>Data not available</span>
    );

    return (
        <Row className="px-1">
            <DataTable 
                  customStyles={tableCustomerStyles} columns={paymentExperienceColumns}
              data={data.paymentExperience}
              ></DataTable>
        </Row>)
  }


  const PFCColumns = [
    {
      name: 'Id',
      selector: data => data.report_access_id.toString(),
      sortable: true,
      width: '33%'
    },
    {
      name: ('Date Accessed'),
      selector: data => data.access_date,
      cell: data => data.access_date.toString().substring(0,2) + '/' + data.access_date.toString().substring(3,5) + '/' + data.access_date.toString().substring(6,10),//data.access_date.toString().substring(5,7) + '/' + data.access_date.toString().substring(8,10) + '/' + data.access_date.toString().substring(0,4),
      sortable: true,
      width: '33%'
    },
    {
      name: ('Cost'),
      selector: data => '$0.00',
      sortable: true,
      wrap: true,
      width: '34%'
    }
    ]
    
  const PFCDataTable = (props) =>
  {
    // alert(JSON.stringify(specialNamesData))

    if (!data) return (
      <span>Data not available</span>
    );

    return (
        <Row className="px-1">
            <DataTable 
                  customStyles={tableCustomerStyles} columns={PFCColumns}
              data={data.pfc}
              ></DataTable>
        </Row>)
  }

    const NSFColumns = [
    {
      name: 'Id',
      selector: data => data.report_access_id.toString(),
      sortable: true,
      width: '33%'
    },
    {
      name: ('Date Accessed'),
      selector: data => data.access_date,
      cell: data => data.access_date.toString().substring(0,2) + '/' + data.access_date.toString().substring(3,5) + '/' + data.access_date.toString().substring(6,10),//data.access_date.toString().substring(5,7) + '/' + data.access_date.toString().substring(8,10) + '/' + data.access_date.toString().substring(0,4),
      sortable: true,
      width: '33%'
    },
    {
      name: ('cost'),
      selector: data => '$0.00',
      sortable: true,
      wrap: true,
      width: '34%'
    }
    ]
    
  const NSFDataTable = (props) =>
  {
    // alert(JSON.stringify(specialNamesData))

    if (!data) return (
      <span>Data not available</span>
    );

    return (
        <Row className="px-1">
            <DataTable 
                  customStyles={tableCustomerStyles} columns={NSFColumns}
              data={data.nsf}
              ></DataTable>
        </Row>)
  }

    

    if (!data.member)
        return (
            <Row>

            </Row>
        )
    return (
        <div class='container-fluid'>
            
            <h3 align="center">CCI Information Services</h3>
            <h4 align="center">Trade Credit Reports</h4>
            <h4 align="center">Customer Usage History</h4>
            <div align="center">&nbsp;</div>
            <h4 align="center">{new Date().toJSON().slice(0, 10)}</h4>
            <hr className="black"></hr>
            <h5 align="center">User Information</h5>
            <div align="center">&nbsp;</div>
            
            <div className="row">
                
                <div className="col">
                    <div>Contact Name: {data.member[0].contact_first_name + " " + data.member[0].contact_last_name}</div>
                    <div>Member Name: {data.member[0].name}</div>
                    <div>Phone: {data.member[0].phone_number}</div>
                </div>
                <div className="col">
                    <div>Address: {data.member[0].address}</div>
                    <div>City: {data.member[0].city}</div>
                    <div>State: {data.member[0].state}</div>
                    <div>Postal Code: {data.member[0].postal_code}</div>
                </div>
                
            </div>
            <div>&nbsp;</div>
            <div className="row">
              <div className="card">
                
                <div className="card-body">
                  <h5 className="card-title">
                  Payment Experience
                </h5>
                <PayementExperienceDataTable />
                </div>
                <div class="d-flex align-items-center justify-content-center">
                <h6>Total Amount: ${props.amountDue}</h6>
                </div>
              </div>
            </div>
            <div>&nbsp;</div>
            <div className="row">
              <div className="card">
                
                <div className="card-body">
                  <h5 className="card-title">
                  Placed For Collections
                </h5>
                <PFCDataTable />
                </div>
              </div>
            </div>
            <div>&nbsp;</div>
            <div className="row">
              <div className="card">
                
                <div className="card-body">
                  <h5 className="card-title">
                  NSF Checks
                </h5>
                <NSFDataTable />
                </div>
              </div>
            </div>
            
            {/* <table width="611" border="0" align="center" cellpadding="0">
            <tr className="style1">
                <td valign="top">-------------------</td>
                <td> </td>
            </tr>
            <tr className="style1">
                <td>{customerRecord[0].address1 != null?customerRecord[0].address1.trim():""}</td>
                <td>File Created: {(customerRecord[0].created_date)?customerRecord[0].created_date.substring(0,10):""}</td>
            </tr>
            <tr className="style1">
                <td>{customerRecord[0].address2 != null?customerRecord[0].address2.trim():""}</td>
                <td>Report Date: {new Date().toJSON().slice(0, 10)}</td>
            </tr>
            <tr className="style1">
                <td>{customerRecord[0].city != null?customerRecord[0].city.trim():""}{", " + customerRecord[0].state + " " + customerRecord[0].zip.substring(0,5) + "-" + customerRecord[0].zip.substring(5,10)}</td>
                <td>{customerRecord[0].attribute_value != null?"Reason Code: " + customerRecord[0].attribute_value  + " - " + customerRecord[0].attribute_description:"Requested By: " + user}</td>
            </tr>
            <tr className="style1">
                <td>{"(" + customerRecord[0].phone.substring(0,3) + ") " + customerRecord[0].phone.substring(3,6) + "-" +  customerRecord[0].phone.substring(6,10)}</td>
                <td>&nbsp;</td>
            </tr>
            </table>
            <hr></hr>
            <ClearingMember props={props}></ClearingMember>
            <div align="center" class="style4">Current Payment Experience</div>
            <div align="center">
            <pre class="style1">-------------Account Status-------------

            </pre>
            </div>
            <></>
            <PaymentExperienceTable props={props}></PaymentExperienceTable>
            <div style={{height: "20px"}}></div>
            <NSFNote></NSFNote>
            <PFCNote></PFCNote>
            
            <hr></hr>
            <div align="center" class="style4">Current Payment Experience Summary</div>
            <div align="center">
                <pre class="style1">-------------Account Status-------------
                </pre>
            </div>
            <SummaryTable props={props}></SummaryTable>
            

            <hr></hr>
            <div align="center" class="style4">Payment Trends</div>
            <div align="center">
                <pre class="style1">-------------Account Status-------------
                </pre>
            </div>
            <TrendTable props={props}></TrendTable>

            <hr></hr>
            <div align="center" class="style4">Current Scores</div>
            <ScoreTable props={props}></ScoreTable>

            <hr></hr>
            <div align="center" class="style4">Score History</div>
            <div style={{height: "20px"}}></div>
            <HistoryTable props={props}></HistoryTable>
            <hr></hr>
            <CustomerGraph accountId={props.accountId} />
            <PlacedForCollections accountId={props.accountId} />
            <NSF accountId={props.accountId} />
            
            <p style={{pageBreakAfter: 'Always'}}>&nbsp;</p>
            */ }

        </div>
        

    )
}